// @ts-nocheck
import React from 'react';
import SelectWorkflow from './SelectWorkflow';

const SelectPodWorkflow = props => (
  <SelectWorkflow {...props} workflowType="podworkflow" placeholder="Select pod workflow" />
);

export default SelectPodWorkflow;
